import { useCallback, memo } from 'react';
import { IconButton } from '@material-ui/core';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { useDataGridTasks } from '../../../hooks/use-data-grid-tasks';

interface Props<R> {
  rowData: R;
  rowUp: null | R;
  rowDown: null | R;
}

const Swap = <R,>({ rowData, rowUp, rowDown }: Props<R>) => {
  const { onTasks } = useDataGridTasks();
  const disableUp = !rowUp;
  const disableDown = !rowDown;

  const onClick = useCallback(
    (targetRow: R) => {
      onTasks([
        [
          'swapData',
          {
            currentRow: rowData,
            targetRow,
          },
        ],
      ]);
    },
    [rowData, onTasks],
  );

  const factoryClick = useCallback(
    (direction: boolean) => {
      const targetRow = direction ? rowUp : rowDown;

      if (!targetRow) return;

      return () => onClick(targetRow);
    },
    [onClick, rowUp, rowDown],
  );

  return (
    <td className="data-grid-col-controls swap">
      <div>
        <IconButton
          aria-label="up"
          className="btn-up"
          tabIndex={-1}
          disabled={disableUp}
          onClick={factoryClick(true)}
        >
          <KeyboardArrowUpIcon fontSize="inherit" />
        </IconButton>
        <IconButton
          aria-label="down"
          className="btn-down"
          tabIndex={-1}
          disabled={disableDown}
          onClick={factoryClick(false)}
        >
          <KeyboardArrowDownIcon fontSize="inherit" />
        </IconButton>
      </div>
    </td>
  );
};

export default memo(Swap) as typeof Swap;
